namespace Ir.Components.Filters.ConditionTypeFilter {
    interface IConditionTypeFilterViewModel{
        filter: Filter;
        conditionTypes: Array<object>;
        disabled: KnockoutComputed<boolean>;
        selectBoxSettings: DevExpress.ui.dxSelectBox.Properties;

        visibleLabel: boolean;
    }

    export function getViewModel(this: IConditionTypeFilterViewModel, params) {
        let self = this;
        this.filter = params.filter;
        this.visibleLabel = params.visibleLabel === undefined ? true : params.visibleLabel;
        
        this.conditionTypes = this.filter.getConditionTypeOptions();

        this.disabled = ko.computed(function () {
            return self.filter.filterEditorType() === FilterEditorTypeEnum.DateRange;
        }.bind(this));

        let availableConditions = this.conditionTypes.filter(function (x) {
            return (x as any).visible(self.filter.filterEditorType(), self.filter.isMetric());
        });

        if (availableConditions.length > 0 && !availableConditions.find(function (x) { return (x as any).id === self.filter.conditionType() })) {
            this.filter.conditionType((availableConditions[0] as any).id);
        }

        this.selectBoxSettings = {
            dataSource: availableConditions,
            displayExpr: 'text',
            valueExpr: 'id',
            value: this.filter.conditionType(),
            width: 110,
            dropDownOptions: {
                width: self.filter.isMetric() ? 130 : (self.filter.isInNotInFilter ? 80 : 100),
            },
            fieldTemplate(data, container) {
                const icon = $(`<div class="icon">${data.icon ?? data.text}</div>`);
                const txt = $("<div>").dxTextBox({
                    value: "",
                    readOnly: true,
                    inputAttr: { 'aria-label': 'Name' },
                });
                const div = $("<div>").append(icon).append(txt);
                container.append(div);
            },
            itemTemplate(data) {
                if (!data.icon) {
                    return `<div><span>${data.text}</span></div>`;
                }
                return `<div><span>${data.icon}  <small>${data.text}</small></span></div>`;
            },
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    self.filter.conditionType(data.value);
                    self.filter.publish();
                }
            }
        }
    }
}